import {
	transformComponentsToLink,
	transformNewsArticlesToCards,
	transformNewsArticleToFeature,
} from '@/helpers/transforms'
import type { LatestNewsBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import { CardListBlock } from '../blocks/CardListBlock'

export const LatestNewsConverter: JSXConverter<SerializedBlockNode<LatestNewsBlock>> = ({
	node,
}) => {
	const { articles, layout, category, viewAllButtonText, viewAllButtonHref } = node.fields
	if (!articles || articles.length === 0) return null

	const button = transformComponentsToLink(viewAllButtonText, viewAllButtonHref)

	if (layout === 'with-featured-article') {
		const [feature, ...cards] = articles
		return (
			<CardListBlock
				featuredCard={transformNewsArticleToFeature(feature, category)}
				cards={transformNewsArticlesToCards(cards, category)}
				button={button}
			/>
		)
	}

	const cards = transformNewsArticlesToCards(articles, category)
	return <CardListBlock cards={cards} button={button} />
}
